var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { observable, observe, action } from "mobx";
import { InternalMessageBusChannels } from "sb-internal-msg-bus";
export class UserInfoObservable {
    constructor(messageBus) {
        this.observers = [];
        this.messageBus = messageBus;
        this.userInfo = {};
        this.subscriptions = [];
    }
    activate() {
        this.subscriptions.push(this.messageBus.getSubscription(InternalMessageBusChannels.legacy.userInfo.onLogin, (message) => this.updateUserInfo(message.data[0]), this));
        this.subscriptions.push(this.messageBus.getSubscription(InternalMessageBusChannels.legacy.userInfo.onLogout, (message) => this.updateUserInfo(message.data[0]), this));
    }
    observe(action) {
        return __awaiter(this, void 0, void 0, function* () {
            yield action();
            this.observers.push(observe(this, "userInfo", action));
        });
    }
    updateUserInfo(userInfo) {
        this.userInfo = userInfo ? userInfo : {};
    }
    deactivate() {
        this.subscriptions.forEach(s => s());
        this.observers.forEach(x => x());
        this.observers = [];
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UserInfoObservable.prototype, "userInfo", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], UserInfoObservable.prototype, "updateUserInfo", null);
//# sourceMappingURL=UserInfoObservable.js.map